module.exports = __webpack_public_path__ + "img/dance.84ea7f9a.png";